var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70001 21.8996C9.90001 19.4996 14.1 19.4996 15.3 21.8996M5.94001 17.0996H18.06C19.4041 17.0996 20.0762 17.0996 20.5896 16.838C21.0412 16.6079 21.4083 16.2408 21.6384 15.7892C21.9 15.2758 21.9 14.6037 21.9 13.2596V5.93961C21.9 4.59548 21.9 3.92342 21.6384 3.41003C21.4083 2.95844 21.0412 2.59129 20.5896 2.36119C20.0762 2.09961 19.4041 2.09961 18.06 2.09961H5.94001C4.59588 2.09961 3.92382 2.09961 3.41043 2.36119C2.95884 2.59129 2.59169 2.95844 2.36159 3.41003C2.10001 3.92342 2.10001 4.59548 2.10001 5.93961V13.2596C2.10001 14.6037 2.10001 15.2758 2.36159 15.7892C2.59169 16.2408 2.95884 16.6079 3.41043 16.838C3.92382 17.0996 4.59588 17.0996 5.94001 17.0996Z",
    stroke: "#403D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.5159eb34f568aad170821b77bb606c2a.svg";
export { ForwardRef as ReactComponent };